import React from 'react';

interface ISquareSmall_02 {
    fill: string;
    id?: string;
}

const SquareSmall_02: React.FC<ISquareSmall_02> = ({ fill, id }) => {
  return (
  <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
  <mask id="mask0_1782_978" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="200" height="200">
  <path d="M0 200H200V-1.06096e-05H0V200Z" fill={fill}/>
  </mask>
  <g mask="url(#mask0_1782_978)">
  <rect x="6" y="-613" width="2" height="1426" fill={fill}/>
  <rect x="54" y="-613" width="2" height="1426" fill={fill}/>
  <rect x="30" y="-613" width="2" height="1426" fill={fill}/>
  <rect x="78" y="-613" width="2" height="1426" fill={fill}/>
  <rect x="18" y="-613" width="2" height="1426" fill={fill}/>
  <rect x="66" y="-613" width="2" height="1426" fill={fill}/>
  <rect x="42" y="-613" width="2" height="1426" fill={fill}/>
  <rect x="90" y="-613" width="2" height="1426" fill={fill}/>
  <rect x="12" y="-613" width="2" height="1426" fill={fill}/>
  <rect x="60" y="-613" width="2" height="1426" fill={fill}/>
  <rect x="36" y="-613" width="2" height="1426" fill={fill}/>
  <rect x="84" y="-613" width="2" height="1426" fill={fill}/>
  <rect x="24" y="-613" width="2" height="1426" fill={fill}/>
  <rect x="72" y="-613" width="2" height="1426" fill={fill}/>
  <rect x="48" y="-613" width="2" height="1426" fill={fill}/>
  <rect y="-613" width="2" height="1426" fill={fill}/>
  <rect x="96" y="-613" width="2" height="1426" fill={fill}/>
  <rect x="102" y="-613" width="2" height="1426" fill={fill}/>
  <rect x="198" y="-613" width="2" height="1426" fill={fill}/>
  <rect x="150" y="-613" width="2" height="1426" fill={fill}/>
  <rect x="126" y="-613" width="2" height="1426" fill={fill}/>
  <rect x="174" y="-613" width="2" height="1426" fill={fill}/>
  <rect x="114" y="-613" width="2" height="1426" fill={fill}/>
  <rect x="162" y="-613" width="2" height="1426" fill={fill}/>
  <rect x="138" y="-613" width="2" height="1426" fill={fill}/>
  <rect x="186" y="-613" width="2" height="1426" fill={fill}/>
  <rect x="108" y="-613" width="2" height="1426" fill={fill}/>
  <rect x="156" y="-613" width="2" height="1426" fill={fill}/>
  <rect x="132" y="-613" width="2" height="1426" fill={fill}/>
  <rect x="180" y="-613" width="2" height="1426" fill={fill}/>
  <rect x="120" y="-613" width="2" height="1426" fill={fill}/>
  <rect x="168" y="-613" width="2" height="1426" fill={fill}/>
  <rect x="144" y="-613" width="2" height="1426" fill={fill}/>
  <rect x="192" y="-613" width="2" height="1426" fill={fill}/>
  </g>
  </svg>
  );
  };
  export default SquareSmall_02;
